import { styled } from 'twin.macro';

const Option = styled.option`
  &.placeholder {
    display: none;
  }
`;

export default Option;